import React from 'react';
import { Container, Row, Col, Nav } from 'react-bootstrap';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { 
  FaTachometerAlt, 
  FaUsers, 
  FaUserTie, 
  FaUserShield,
  FaKey,
  FaCoins,
  FaExchangeAlt,
  FaBox,
  FaEnvelope,
  FaHistory,
  FaUserCircle,
  FaSignOutAlt
} from 'react-icons/fa';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'react-toastify';

const Layout = () => {
  const { user, logout, hasRole } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };

  return (
    <Container fluid className="p-0">
      <Row className="g-0">
        <Col md={2} className="sidebar">
          <div className="p-3 text-white">
            <h4 className="mb-4">ADG Panel</h4>
            <Nav className="flex-column">
              <NavLink to="/dashboard" className="nav-link">
                <FaTachometerAlt /> Dashboard
              </NavLink>
              
              <NavLink to="/users" className="nav-link">
                <FaUsers /> End Users
              </NavLink>
              
              {hasRole(['super_admin', 'admin']) && (
                <NavLink to="/resellers" className="nav-link">
                  <FaUserTie /> Resellers
                </NavLink>
              )}
              
              {hasRole(['super_admin']) && (
                <NavLink to="/admins" className="nav-link">
                  <FaUserShield /> Admins
                </NavLink>
              )}
              
              <NavLink to="/licenses" className="nav-link">
                <FaKey /> Licenses
              </NavLink>
              
              {hasRole(['super_admin', 'admin']) && (
                <>
                  <NavLink to="/credits" className="nav-link">
                    <FaCoins /> Credit Mgmt
                  </NavLink>
                </>
              )}

              <NavLink to="/transactions" className="nav-link">
                <FaExchangeAlt /> Credit History
              </NavLink>
              
              <NavLink to="/packages" className="nav-link">
                <FaBox /> Packages
              </NavLink>
              
              {hasRole(['super_admin']) && (
                <>
                  <NavLink to="/smtp-settings" className="nav-link">
                    <FaEnvelope /> SMTP Settings
                  </NavLink>
                  
                  <NavLink to="/audit-logs" className="nav-link">
                    <FaHistory /> Audit Logs
                  </NavLink>
                </>
              )}
              
              <hr className="bg-light" />
              
              <NavLink to="/profile" className="nav-link">
                <FaUserCircle /> Profile
              </NavLink>
              
              <Nav.Link onClick={handleLogout} className="nav-link" style={{ cursor: 'pointer' }}>
                <FaSignOutAlt /> Logout
              </Nav.Link>
            </Nav>
          </div>
        </Col>
        
        <Col md={10} className="main-content">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2>Welcome, {user?.name}</h2>
            <div>
              <span className="badge bg-primary me-2">{user?.role?.replace('_', ' ')?.toUpperCase()}</span>
              {hasRole(['admin', 'reseller']) && (
                <span className="badge bg-success">Credits: {user?.credits || 0}</span>
              )}
            </div>
          </div>
          
          <Outlet />
        </Col>
      </Row>
    </Container>
  );
};

export default Layout;
